import React, { useCallback, useMemo, useReducer } from 'react';

import alertConstants from './alert.constants';
import AlertContext from './alert.context';
import alertReducer from './alert.reducer';
import alertInitialState from './alert.state';

/**
 * @type {React.FC}
 */
const AlertProvider = function({
  children,
  value = alertInitialState,
}) {
  const [state, dispatch] = useReducer(alertReducer, value);

  const hideAlert = useCallback((key) => {
    dispatch({
      key,
      type: alertConstants.HIDE_ALERT,
    });
  }, [dispatch]);
  const showAlert = useCallback((messageType, message) => {
    dispatch({
      type: alertConstants.SHOW_ALERT,
      messageType,
      message,
    });
  }, [dispatch]);

  const context = useMemo(() => ({
    ...state,
    hideAlert,
    showAlert,
  }), [hideAlert, showAlert, state]);

  return (
    <AlertContext.Provider value={context}>
      {children}
    </AlertContext.Provider>
  );
};

export default AlertProvider;